const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page049_game0/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 245,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a01',
      src: 'games/page049_game0/audio/65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 295,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a01',
      src: 'games/page049_game0/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 355,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a01',
      src: 'games/page049_game0/audio/69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 410,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page049_game0/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 245,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page049_game0/audio/67_jumper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 295,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page049_game0/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 355,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page049_game0/audio/70_jeans.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 410,
        x: 70,
      },
      unit: 'px',
    },
    //aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
    {
      id: 'a03',
      src: 'games/page049_game0/audio/66_dress.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 215,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page049_game0/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 265,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page049_game0/audio/65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 310,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page049_game0/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 360,
        x: 70,
      },
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page049_game0/audio/69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page049_game0/img/audioOn.png', iconOff: 'games/page049_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 70 + 410,
        x: 70,
      },
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page049_game0/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 5 },
    { connectId: 2, connectedWith: 6 },
    { connectId: 3, connectedWith: 4 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page049_game0/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page049_game0/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page049_game0/audio/true.mp3', id: 'ok' },
  ],
  groups: [
    {
      name: 'left',
      // disableShuffle: true,

      items: [
        {
          audio: 'a01',
          connectId: 1,
          audioId: 'ok',
          image: { src: 'games/page049_game0/img/1.webp' },
          imageStyle: { position: 'absolute', width: '308px', height: '537px' },
          pos: {
            x: 235,
            y: 105,
            width: 308,
            height: 537,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 274 / 2, y: 537 }],
        },
        {
          audio: 'a02',
          connectId: 2,
          audioId: 'ok',
          image: { src: 'games/page049_game0/img/2.webp' },
          imageStyle: { position: 'absolute', width: '308px', height: '537px' },
          pos: {
            x: 775,
            y: 105,
            width: 308,
            height: 537,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 274 / 2, y: 537 }],
        },
        {
          audio: 'a03',
          connectId: 3,
          audioId: 'ok',
          image: { src: 'games/page049_game0/img/3.webp' },
          imageStyle: { position: 'absolute', width: '308px', height: '537px' },
          pos: {
            x: 1300,
            y: 105,
            width: 308,
            height: 537,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 274 / 2, y: 537 }],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          connectId: 4,
          image: { src: 'games/page049_game0/img/aaab.webp' },
          imageStyle: { position: 'absolute', width: '282px', height: '310px' },
          pos: {
            x: 240,
            y: 750,
            width: 282,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 282 / 2, y: 0 }],
        },
        {
          connectId: 5,
          image: { src: 'games/page049_game0/img/aaab.webp' },
          imageStyle: { position: 'absolute', width: '282px', height: '310px' },
          pos: {
            x: 780,
            y: 750,
            width: 282,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 282 / 2, y: 0 }],
        },
        {
          connectId: 6,
          image: { src: 'games/page049_game0/img/aaab.webp' },
          imageStyle: { position: 'absolute', width: '282px', height: '310px' },
          pos: {
            x: 1315,
            y: 750,
            width: 282,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 282 / 2, y: 0 }],
        },
      ],
    },
  ],
};
export default config;
